import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'kyc';
let loaded = loadState(STORE_KEY) || [];

const state = {
	kycData: loaded.kycData || [],
};

const mutations = {
	SET_KYC_DATA(state, kyc) {
		state.kycData = kyc;
		saveState(STORE_KEY, state);
	},
};

const actions = {
	setKycData({ commit }, data) {
		commit('SET_KYC_DATA', data);
	},
};

const getters = {
	selectKycData: (state) => state.kycData,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
